"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Questions(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M19 3c1.093 0 2 .907 2 2v14c0 1.093-.907 2-2 2H9c-1.093 0-2-.907-2-2V5c0-1.093.907-2 2-2zm0 2H9v14h10V5zm-6 12h2v-2h-2v2zm1-10c-.907 0-1.715.381-2.232.957A3.043 3.043 0 0 0 11 10h2c0-.268.1-.533.256-.707.156-.174.348-.293.744-.293.405 0 .6.118.75.283.15.165.25.421.25.717 0 .565-.271.903-.756 1.463C13.759 12.022 13 12.798 13 14h2c0-.335.241-.633.756-1.227C16.271 12.18 17 11.286 17 10c0-.743-.248-1.487-.771-2.063C15.705 7.362 14.897 7 14 7zM3 20h2V4H3v16z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Questions;
